import { ErrorInfo } from 'react'

import { getOrganizationIdFromUrl } from '~/helpers/sessionHelpers'

const generateLogger =
  (level: 'error' | 'info' | 'debug' | 'warn') =>
  (message: string, messageContext?: Record<string, unknown> | ErrorInfo): void => {
    console[level](message, {
      ...messageContext,
      organization: getOrganizationIdFromUrl(),
    })
  }

const logger = {
  error: generateLogger('error'),
  info: generateLogger('info'),
  warn: generateLogger('warn'),
  debug: generateLogger('debug'),
}

export default logger
